import { render } from "./Meetingrooms.vue?vue&type=template&id=c829d3fa"
import script from "./Meetingrooms.vue?vue&type=script&lang=js"
export * from "./Meetingrooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__